<form class="pt3" [formGroup]="bookerMultiCityStore.flights$ | async">
  <dot-multi-city-row
    *ngFor="
      let flight of (this.bookerMultiCityStore.flights$ | async).controls;
      let index = index;
      let first = first
    "
    [ngClass]="{ db: true, pt2: !first }"
    [index]="index"
    [content]="content"
    [autoPrePopulateOrigin]="first"
    [regions]="regions"
    [origins]="allFilteredAirports$ | async"
    [flight]="flight"
    [recentAirports]="recentAirports && recentAirports[index]"
    [separatePartnerCities]="separatePartnerCities"
    [showValidationErrors]="showValidationErrors"
    [formWrapper]="formWrapper"
    (eitherAirportChange)="handleAirportChange($event, index)"
  ></dot-multi-city-row>
  <jb-action
    actionIcon="addElement"
    (click)="addNewRow()"
    *ngIf="!(isMaxFlights$ | async)"
    class="pt3 absolute-l absolute-m"
  >
    {{ content?.bookMessages?.multicity?.addFlight }}
  </jb-action>
</form>
